"use client";

import { useState } from "react";
import { ArrowRight, Compass } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Territory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const [activeRegion, setActiveRegion] = useState<number | null>(null);
  const zones = [{
    name: "Coastal Zone",
    detail: "08 TEAMS · 220 ROOFS · 24/7 OPS",
    cx: 74,
    cy: 38
  }, {
    name: "Harbor Front",
    detail: "06 TEAMS · 180 ROOFS · 24/7 OPS",
    cx: 78,
    cy: 72
  }, {
    name: "West Heights",
    detail: "14 TEAMS · 360 ROOFS · 24/7 OPS",
    cx: 56,
    cy: 38
  }];
  const routes = [{
    from: 0,
    to: 4
  }, {
    from: 7,
    to: 4
  }, {
    from: 5,
    to: 2
  }, {
    from: 0,
    to: 3
  }, {
    from: 7,
    to: 5
  }];
  return <section data-section-id="822" id="our-service-territory" className="bg-background text-foreground relative overflow-hidden py-20 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: "radial-gradient(circle, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "24px 24px"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        {}
        <div className="mb-14 md:mb-20 max-w-3xl">
          
          
          
        </div>

        {}
        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          {}
          <div className="lg:col-span-8 relative">
            
          </div>

          {}
          
        </div>
      </div>
    </section>;
}